import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "../styles/pages/GetCardStyles";
import useLanguage from "../hooks/useLanguage";

function isMobileDevice() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return (
    /android|iphone|ipad|ipod|iemobile|opera mini|blackberry|webos/i.test(ua) ||
    (typeof window !== "undefined" &&
      window.matchMedia?.("(pointer:coarse)")?.matches)
  );
}

function GetCard(props) {
  const history = useHistory();
  const classes = useStyles(props);

  const {
    pages: { getCard: STRINGS },
  } = useLanguage();

  const handleOpenVerification = useCallback(() => {
    const base = `https://www.lider-bet.com/${
      isMobileDevice() ? "m" : "web"
    }/ka/user/#user_personal_info/verification`;
    window.open(base, "_blank", "noopener,noreferrer");
  }, []);

  return (
    <Grid item container xs={11} md={8} className={classes.contentContainerGrid}>
      <Grid item className={classes.card}>
        <Typography variant="h1" className={classes.title}>
          {STRINGS.title}
        </Typography>

        <Typography variant="body1" className={classes.paragraph}>
          {STRINGS.p1_before}{" "}
          <button type="button" onClick={handleOpenVerification} className={classes.inlineLinkBtn}>
            {STRINGS.p1_link}
          </button>{" "}
          {STRINGS.p1_after}.
        </Typography>

        <Typography variant="body1" className={classes.paragraph}>
          {STRINGS.p2}
        </Typography>

        <div className={classes.actions}>
    
          <button type="button" onClick={() => history.push(`/atms`)} className={classes.primaryBtn}>
            {STRINGS.linkText} &#x2192;
          </button>
        </div>
      </Grid>
    </Grid>
  );
}

export default GetCard;
